import
  React, {
  PureComponent
} from 'react';

import {
  Base
} from '@vodacom/web-common';

import {
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis
} from 'recharts';

import {
  CustomColors,
  ErrorKeys
} from '../../../constants';

import {
  HandleRender
} from 'hocs';

class CustomizedLabel extends PureComponent {
  render() {
    const { x, y, stroke, value } = this.props;

    return (
      <>
        <text
          x={x}
          y={y}
          dy={-12}
          fill={stroke}
          fontSize={16}
          textAnchor='middle'>

          {value}
        </text>
      </>
    );
  }
}

export const WeatherChart = props => {

  const Chart = () => {

    let chartData = [];
    props.forecast
      ?.forEach((day, index) => {

        if (index !== 0 && index <= 5) {
          chartData.push(

            {
              day: day.day,
              low: day.min,
              high: day.max
            }
          );
        }
      });

    return (

      <Base
        margin={'20px 0 0 0'}
        width={'100%'}
        height={'350px'}>

        <ResponsiveContainer
          width={'100%'}
          height={'100%'}>

          <LineChart
            margin={{ top: 30, right: 47, bottom: 5, left: 47 }}
            width={300}
            height={100}
            data={chartData}>

            <XAxis
              dataKey={'day'}
              axisLine={false}
              tick={{ fontWeight: 'bold', fontSize: '20px' }}
              tickLine={false}
              domain={[
                0, 4
              ]} />

            <YAxis
              axisLine={false}
              tickLine={false}
              width={0}
              domain={[
                'dataMin-2', 'dataMax+2'
              ]} />

            <Line
              type='linear'
              dataKey='high'
              isAnimationActive={false}
              stroke={CustomColors.Red1}
              label={<CustomizedLabel />}
              dot={{ stroke: CustomColors.Red1, strokeWidth: 6 }} />

            <Line
              type='linear'
              dataKey='low'
              isAnimationActive={false}
              stroke={CustomColors.Blue1}
              label={<CustomizedLabel />}
              dot={{ stroke: CustomColors.Blue1, strokeWidth: 6 }} />
          </LineChart>
        </ResponsiveContainer>
      </Base>
    );
  };

  return (

    <HandleRender
      isLoading={false}
      isError={props.forecast?.length < 2}
      error={{ type: ErrorKeys.General, title: 'WEATHER CHART' }}>

      <Chart/>

    </HandleRender>
  );
};